import { fabric } from "fabric";

export class CrayonBrush extends fabric.PatternBrush {
  constructor(canvas, color = "#000") {
    super(canvas);
    this.color = color;
    this.patternCanvas = this._makePattern();
    this.source = this.patternCanvas;
  }

  // Build a grainy texture for the stroke
  _makePattern() {
    const size = 20; // size of the pattern tile
    const c = fabric.util.createCanvasElement();
    c.width = c.height = size;

    const ctx = c.getContext("2d");
    ctx.fillStyle = this.color;

    // Add random noise-like dots to simulate crayon
    for (let i = 0; i < 60; i++) {
      const x = Math.random() * size;
      const y = Math.random() * size;
      const alpha = 0.2 + Math.random() * 0.5; // random transparency
      ctx.globalAlpha = alpha;
      ctx.fillRect(x, y, 1, 1);
    }

    ctx.globalAlpha = 1; // reset
    return c;
  }

  // Override to update when color changes
  setColor(color) {
    this.color = color;
    this.patternCanvas = this._makePattern();
    this.source = this.patternCanvas;
  }
}
